import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useOutsideClick } from 'rooks';

import { MotifVerticalNavigationMenuItem } from './vertical-navigation-menu/vertical-navigation-menu-item';
import { MotifVerticalNavigationMenu } from './vertical-navigation-menu/vertical-navigation-menu';
// import { MotifTooltip } from '../tooltip/tooltip';

/**
 * @typedef Props
 * @prop {React.ReactNode} children
 * @prop {string} title
 * @prop {string} [className]
 * @prop {React.ReactNode} [icon]
 * @prop {() => void} [onClick]
 * @prop {string} [value]
 * @prop {boolean} [collapse]
 * @prop {string} [tooltipLabel]
 * @prop {string} [guidanceText]
 */
/**
 * @param {Props} props
 */
const MotifVerticalNavigationContextSwitcher = ({
    className = '',
    icon = null,
    title,
    children,
    value = '',
    collapse = false,
    onClick,
    tooltipLabel = '',
    // tooltipVariant,
    guidanceText = 'SWITCH TO'
}) => {
    const switcherMenuRef = useRef();
    const [open, setOpen] = useState(!collapse);

// Code to create a custom MotifTooltip for contextSwitcher items. Currently superseded by the HTML tooltip
// eslint-disable-next-line multiline-comment-style
/*  const [topSw, setTopSw] = useState('');

    useEffect(() => {
        updateTooltipPosition();
      }, [switcherMenuRef.current, collapse]);

    const customMotifTooltip = () =>
    <MotifTooltip
        trigger={innerElement}
        placement="left"
        contentClassName="switcher-tooltip"
        variant={tooltipVariant}
        style={styleTooltip}
        allowClick={false}
    >
      {tooltipLabel || value || title}
    </MotifTooltip>;

    const styleTooltip = {
        color: 'green',
        transform: `translate3d(${collapse ? 'var(--vertical-navigation-collapsed-width)' : 'var(--vertical-navigation-expanded-width)'}, ${topSw}, 0)`,
        position: 'absolute',
        willChange: 'transform',
        top: '0px'
    };

    const updateTooltipPosition = () => {
        const windowScroll = window.pageYOffset || document.documentElement.scrollTop;
        const switcherPosition = switcherMenuRef.current.getBoundingClientRect().top;
        setTopSw(`${(windowScroll + switcherPosition)}px`);
    };

    const handleHover = () => {
        updateTooltipPosition();
    };*/

    const classes = classNames({
        'motif-context-switcher': true,
        [className]: true
      });

    const menuClasses = classNames({
        'motif-vertical-navigation-submenu-open': !collapse
    });

    const handleClickOutside = () => {
        setOpen(false);
    };

    useOutsideClick(switcherMenuRef, handleClickOutside);

    const handleClick = () => {
        if (collapse) {
            onClick();
            setOpen(true);
        } else {
            setOpen(prevSate => !prevSate);
        }
    };

    const innerElement =
    <MotifVerticalNavigationMenu>
        <MotifVerticalNavigationMenuItem
            icon={React.cloneElement(icon, { title: tooltipLabel || title })}
            selected={false}
            className={menuClasses}
            label={tooltipLabel || title}
            onMouseOver={() => null}
            open={false}
            onClick={handleClick}
        >
            {!collapse && (value || title)}
        </MotifVerticalNavigationMenuItem>
    </MotifVerticalNavigationMenu>;

  return (
    <div
    className={classes}
    ref={switcherMenuRef}
    >
        {innerElement}
        {open && !collapse &&
        <div className="motif-context-switcher-option motif-vertical-navigation-scrolls">
            <div className="motif-context-switcher-guidance-text">
                {guidanceText}
            </div>
            {children}
        </div>}
    </div>
  );
};

MotifVerticalNavigationContextSwitcher.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    icon: PropTypes.node,
    value: PropTypes.string,
    title: PropTypes.string.isRequired,
    collapse: PropTypes.bool,
    onClick: PropTypes.func,
    tooltipLabel: PropTypes.string,
    // tooltipVariant: PropTypes.string,
    guidanceText: PropTypes.string
};

export { MotifVerticalNavigationContextSwitcher };
